import { MBBaseSystemMessage } from '@shared/scenes/chat/thread/components/message/system/base';
import { MBSystemMessageProps } from '@shared/scenes/chat/thread/components/message/system/index';
import { type API } from '@shared/types/api';
import { getIcon, getIconColor } from './systemMessageCardUtils';

export function Card({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      icon={getIcon(message as API.ChatMessageFragment)}
      color={getIconColor(message as API.ChatMessageFragment)}
      text={message.content}
      date={message.createdAt}
    />
  );
}
